import { ItiBaseDto } from '@/iti-core-vue';

export class Evento extends ItiBaseDto {
    public id!: number;
    public text!: string;
    public description!: string;
    public endDate!: Date;
    public startDate!: Date;
    public userId!: number;
    public recurrenceRule!: string;
    public alllDay!: boolean;
    public color!: string;
    public completed!: boolean | null;
    public ambitId!: number;
}
